<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover" class="imagefp" src="Images/MSRCover.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780743459419_cov.vue?29abb9fb